import { currentPreviewKeyAtom, rootFileInfoAtom, rootFileMetadataAtom, rootPreviewKeyAtom, } from 'js/file_viewer/core/atoms/metadata';
import { useFileViewerAtomValue } from 'js/file_viewer/core/atoms/use_atom';
import { isNestedArchiveFilePreviewKey } from 'js/file_viewer/core/data/preview_key';
import { usePreviewMetadataForPreviewKey } from 'js/file_viewer/core/queries/preview_metadata';
import { useArchiveEntry } from 'js/file_viewer/core/queries/riviera_preview_types/utils/archive';
export const useRootPreviewKey = () => useFileViewerAtomValue(rootPreviewKeyAtom);
export const useCurrentPreviewKey = () => useFileViewerAtomValue(currentPreviewKeyAtom);
/**
 * @returns {ResolvedFileInfo}
 *   fileInfo for the current file. If using a root file or a folder within an archive, this will be the same as
 *   rootFileInfo. Undefined if viewing a nested archive file.
 * @todo When PreviewMetadata is moved to Jotai, this can become an atom composed of previewMetadataAtom and
 *   rootFileInfoAtom.
 */
const useCurrentFileInfo = () => {
    const currentPreviewKey = useCurrentPreviewKey();
    const rootFileInfo = useFileViewerAtomValue(rootFileInfoAtom);
    const isNestedArchiveFile = currentPreviewKey
        ? isNestedArchiveFilePreviewKey(currentPreviewKey)
        : false;
    const currentFileInfo = rootFileInfo && !isNestedArchiveFile ? rootFileInfo : undefined;
    return currentFileInfo;
};
export const useCurrentFileMetadata = () => {
    var _a;
    const rootPreviewKey = useRootPreviewKey();
    const rootFileMetadata = useFileViewerAtomValue(rootFileMetadataAtom);
    const currentPreviewKey = useCurrentPreviewKey();
    const rootPreviewMetadata = usePreviewMetadataForPreviewKey(rootPreviewKey);
    const currentPath = currentPreviewKey && isNestedArchiveFilePreviewKey(currentPreviewKey)
        ? currentPreviewKey.subpath
        : undefined;
    const archiveEntry = useArchiveEntry(rootPreviewKey, rootPreviewMetadata, currentPath);
    if (!archiveEntry) {
        return rootFileMetadata;
    }
    return rootFileMetadata && archiveEntry && !archiveEntry.isDir
        ? {
            file_name: archiveEntry.name,
            file_collection_context: rootFileMetadata.file_collection_context,
            size: (_a = archiveEntry.size) !== null && _a !== void 0 ? _a : 0,
            readOnly: true,
        }
        : rootFileMetadata;
};
export function usePreviewState(previewKey) {
    const fileMetadata = useCurrentFileMetadata();
    const previewMetadata = usePreviewMetadataForPreviewKey(previewKey);
    const currentFileInfo = useCurrentFileInfo();
    return {
        fileMetadata,
        previewMetadata,
        fileInfo: currentFileInfo,
    };
}
//# sourceMappingURL=selectors.preenvesnextjs.map
